<template>
  <component
    class="editor editor__content"
    :is="renderHtml"
    v-if="content"
  />
</template>

<script setup>
import { computed, h } from 'vue'
import { useConsent } from '@/vendors/consent'
import { pick as _pick, mapValues as _mapValues } from 'lodash'

import AppConsentPlaceholder from '&/atoms/AppConsentPlaceholder'

const { content, tag } = defineProps({
  tag: { type: String, default: 'div' },
  content: String
})

const { hasMarketingConsent } = useConsent()

const requiresConsentForIframe = computed(() => /<iframe\b[^>]*>(.*?)<\/iframe>|<iframe\b[^>]*>/i.test(content))

const renderHtml = computed(() => {
  if (!requiresConsentForIframe.value || hasMarketingConsent.value) return h(tag, { innerHTML: content })

  const parser = new DOMParser()
  const doc = parser.parseFromString(content, 'text/html')

  const nodes = renderNodes(doc.body.childNodes)

  return nodes.length === 1 ? nodes[0] : h(tag, {}, nodes)
})

const renderNodes = nodeList => {
  return Array.from(nodeList)
    .map(node => {
      if (node.nodeType === Node.TEXT_NODE) return node.textContent

      if (node.nodeType === Node.ELEMENT_NODE) {
        const attrs = {}
        const tag = node.nodeName.toLowerCase()

        for (const attr of node.attributes) attrs[attr.name] = attr.value

        if (tag === 'iframe') {
          const props = _mapValues(_pick(attrs, ['width']), value => /(px|%)/.test(value) ? `min(${value}, 100%)` : `min(${value}px, 100%)` )

          return h(AppConsentPlaceholder, props)
        }

        return h(tag, attrs, renderNodes(node.childNodes))
      }

      return null
    })
    .filter(Boolean)
}
</script>